import { loadStripe, Stripe } from '@stripe/stripe-js';

import { Country as CountryCode } from '@rafflebox-technologies-inc/rafflebox-schema';

import config from '@/config';

export { Stripe };

export default {
  /**
   * Retrieves Stripe Platform Account based on the `countryCode` provided.
   * @param {*} countryCode `"US"` or `"CA"`.
   */
  async retrieveStripePlatformAccount(countryCode: CountryCode) {
    switch (countryCode) {
      case 'CA':
        return await loadStripe(config.STRIPE_PUBLIC_CA_KEY, { apiVersion: '2016-07-06' });
      case 'US':
        return await loadStripe(config.STRIPE_PUBLIC_US_KEY, { apiVersion: '2016-07-06' });
    }
  }
};
